var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"family_group"},[_c('NftCard',{attrs:{"payload":_vm.payload,"utxo":_vm.utxos[0],"group-i-d":_vm.groupID,"quantity":_vm.quantity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }